import React from "react";
import { Form, Input, Row, Col, Card, Button } from "antd";

const Pungutan = ({ data, setData }) => {
    return (
        <Form layout="vertical">
            <Card title="Pungutan" extra={<Button>Generate Pungutan</Button>}>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Pungutan">
                            <Input placeholder="" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Ditangguhkan">
                            <Input placeholder="" />
                        </Form.Item>
                    </Col>
                </Row>
            </Card>
        </Form>
    );
};

export default Pungutan;
